import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  ArrowLeft, FileText, ShieldCheck, Cookie, AlertTriangle, RefreshCw,
  Scale, CalendarCheck, FileSignature, Database,
} from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

const docs = [
  { to: '/legal/privacy',            label: 'Privacy Policy',             icon: ShieldCheck },
  { to: '/legal/terms',              label: 'Terms of Service',           icon: FileText },
  { to: '/legal/trial-terms',        label: 'Free Trial Terms',           icon: CalendarCheck },
  { to: '/legal/service-agreement',  label: 'Service Agreement',          icon: FileSignature },
  { to: '/legal/cookies',            label: 'Cookie Policy',              icon: Cookie },
  { to: '/legal/acceptable-use',     label: 'Acceptable Use Policy',      icon: AlertTriangle },
  { to: '/legal/refund',             label: 'Refund & Cancellation',      icon: RefreshCw },
  { to: '/legal/dpa',                label: 'Data Processing Agreement',  icon: Database },
  { to: '/legal/asa',                label: 'UK ASA Compliance',          icon: Scale },
];

const LegalLayout = ({ title, lastUpdated, children }) => {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-[#fdfaf6] flex flex-col" data-testid="legal-layout">
      <Navbar />
      <div className="flex-1 max-w-6xl mx-auto w-full px-5 lg:px-8 py-10">
        <Link to="/legal" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6">
          <ArrowLeft className="w-4 h-4" /> All legal documents
        </Link>

        <div className="grid lg:grid-cols-[260px_1fr] gap-10">
          <aside className="hidden lg:block">
            <div className="sticky top-6 space-y-1">
              {docs.map(d => {
                const Icon = d.icon;
                const active = pathname === d.to;
                return (
                  <Link
                    key={d.to}
                    to={d.to}
                    data-testid={`legal-nav-${d.to.split('/').pop()}`}
                    className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${
                      active ? 'bg-orange-50 text-orange-700 font-semibold' : 'text-slate-600 hover:bg-slate-100'
                    }`}
                  >
                    <Icon className="w-4 h-4 flex-shrink-0" /> <span className="truncate">{d.label}</span>
                  </Link>
                );
              })}
            </div>
          </aside>

          <article className="bg-white rounded-2xl border border-slate-200 p-6 lg:p-10 shadow-sm">
            <div className="border-b border-slate-100 pb-4 mb-6">
              <h1 className="text-2xl lg:text-3xl font-extrabold text-slate-900 tracking-tight">{title}</h1>
              {lastUpdated && (
                <p className="mt-1 text-sm text-slate-500">Version 1.0 · Last updated: {lastUpdated}</p>
              )}
            </div>
            <div className="prose prose-slate max-w-none prose-headings:font-bold prose-headings:text-slate-900 prose-h2:text-xl prose-h2:mt-8 prose-h3:text-base prose-p:text-slate-700 prose-li:text-slate-700 prose-a:text-orange-600 prose-strong:text-slate-900 prose-table:text-sm">
              {children}
            </div>
            <div className="mt-10 pt-6 border-t border-slate-100 text-xs text-slate-500 space-y-1.5">
              <p><strong>Service Provider:</strong> Krinal Ahir Ltd, trading as MyBusinessAdPro.</p>
              <p><strong>Company Number:</strong> 11940942. <strong>Registered Office:</strong> The Spinney, 12 Scothern Lane, Sudbrooke LN2 2QT.</p>
              <p><strong>Contact:</strong> <a href="mailto:contact@mybusinessadpro.co.uk" className="text-orange-600 font-medium">contact@mybusinessadpro.co.uk</a></p>
            </div>
          </article>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export { docs };
export default LegalLayout;
